class VKCustomizableProductSection extends HTMLElement {
  constructor() {
    super();
    this.config = window.vkcf;
    this.canvas = document.querySelector(`#VKCanvas-${this.dataset.section}`);
    this.fieldset = this.querySelector('fieldset');
    this.block = this.getBlockSettings(this.fieldset);
    this.textarea = this.querySelector('textarea');
    this.textSizeController = this.querySelector('.vkcf-controls .text-size');
    this.textAlignController = this.querySelector('.vkcf-controls .text-align');
    this.selectedSize = null;
    this.selectedAlignment = null;
    this.maxLines = 0;
    this.lineCharacterLimit = 0;
    this.allowedSpecialChars = ['♦', '♥', '❤', '…', '“', '”', '‘', '’', '—']; // ["♦", "♥", "❤️", "😀"]; ちは
    this.textLayerSettings = null;
    this.canvasLabel = null;

    this.cachedText = '';
    this.preservedText = null;
    this.isChangeSizeEvent = false;

    this.dev = false;

    this.init();
  }

  init() {
    this.log(`Init ${this.block.id}`, {
      settings: this.block,
    });

    this.createControls();
    this.controlTextarea();
  }

  controlTextarea() {
    const textarea = this.textarea;

    this.textarea.addEventListener('input', this.limitCharacters.bind(this));

    // focus textarea when clicking on the .textarea-wrapper
    this.fieldset.querySelector('.textarea-wrapper').addEventListener('click', function () {
      textarea.focus();
    });
  }

  limitCharacters(event) {
    if (typeof event.inputType === 'undefined' && this.preservedText !== null) {
      event.target.value = this.preservedText;
    } else {
      this.preservedText = null;
    }

    // Regex to remove non-Unicode characters but allow special characters
    const regex = new RegExp('[^\u0000-\u00ff' + this.allowedSpecialChars.join('') + ']', 'g');

    if (regex.test(event.target.value)) {
      // Remove regex matches
      event.target.value = event.target.value.replace(regex, '');
    }

    // Convert to uppercase
    event.target.value = event.target.value.toUpperCase();

    // Prevent writing more than the max number of lines
    while (this.textarea.clientHeight < this.textarea.scrollHeight) {
      event.target.value = event.target.value.substr(0, event.target.value.length - 1);
    }

    // Update the canvas text
    this.cachedText = this.canvas.updateLayerText(this.canvasLabel, event.target.value, this.isChangeSizeEvent);

    // Remove setting just after the text is updated
    if (this.isChangeSizeEvent === true) {
      this.isChangeSizeEvent = false;
    }

    this.textarea.value = this.cachedText;
  }

  addLineBreaks(text, textarea, canvas) {
    let lines = text.split('\n');
    let newLines = [];
    let context = canvas.getContext('2d');
    let textareaWidth = parseFloat(window.getComputedStyle(textarea).width) + 1.8;
    context.font = window.getComputedStyle(textarea).font;

    for (let i = 0; i < lines.length; i++) {
      let line = lines[i];
      // const initialWords = line.split(" ");
      const initialWhitespaces = line.match(/^\s+/) || '';
      const initialWords = line.trimStart().split(' ');
      let lineWords = [];
      let newLine = '';

      if (initialWhitespaces) {
        initialWords.unshift(initialWhitespaces[0]);
      }

      // check if words exceed the max number of characters per line
      if (this.lineCharacterLimit !== 0) {
        initialWords.forEach((word) => {
          word = word.replace(new RegExp(`\\b(.{${this.lineCharacterLimit},})\\b`, 'g'), (match) => match.match(new RegExp(`.{1,${this.lineCharacterLimit}}`, 'g')).join('\n'));
          lineWords = lineWords.concat(word.split('\n'));
        });
      }

      for (let j = 0; j < lineWords.length; j++) {
        let word = lineWords[j];

        let whiteSpace = newLine.trim() === '' ? '' : ' ';
        let testLine = newLine + whiteSpace + word;
        let metrics = context.measureText(testLine);
        let testWidth = metrics.width;

        if (testWidth === 0) {
          testLine = testLine.trimEnd();
        }

        if (testWidth > textareaWidth) {
          newLines.push(newLine);
          newLine = word;
        } else {
          newLine = testLine;
        }
      }

      if (newLines.length < this.maxLines) {
        newLines.push(newLine);
      }
    }

    // console.log(newLines);

    return newLines.join('\n');
  }

  createControls() {
    const haveMultipleSizes = this.block.options.sizes && Object.keys(this.block.options.sizes).length > 1;
    const haveMultipleAlignments = this.block.options.alignments && Object.keys(this.block.options.alignments).length > 1;

    if (!haveMultipleSizes) {
      this.textSizeController.style.display = 'none';
    }
    if (!haveMultipleAlignments) {
      this.textAlignController.style.display = 'none';
    }

    // Create the controls
    Object.keys(this.block.options.sizes).forEach((obj) => {
      const size = this.block.options.sizes[obj];
      let buttonClass = `size-controller__button--${size.name}`;

      if (size?.default) {
        buttonClass += ' selected';
        this.selectedSize = size.name;
        this.maxLines = size.maxLines;
        this.lineCharacterLimit = size.lineCharacterLimit;
      }

      // this.textSizeController.innerHTML += `<button class="${buttonClass}" data-size="${size.name}">${size.displayName}</button>`;
      this.textSizeController.innerHTML += `<button class="${buttonClass}" data-size="${size.name}"></button>`;
    });

    Object.keys(this.block.options.alignments).forEach((obj) => {
      const align = this.block.options.alignments[obj];
      let buttonClass = `align-controller__button--${align.name}`;

      if (align?.default) {
        this.selectedAlignment = align.name;
        buttonClass += ' selected';
      }

      // this.textAlignController.innerHTML += `<button class="${buttonClass}" data-align="${align.name}">${align.displayName}</button>`;
      this.textAlignController.innerHTML += `<button class="${buttonClass}" data-align="${align.name}"></button>`;
    });

    this.updateDisplay();

    this.textSizeController.addEventListener('click', this.controlTextSize.bind(this));
    this.textAlignController.addEventListener('click', this.controlTextAlign.bind(this));
  }

  controlTextSize(event) {
    // do nothing if is already selected
    if (event.target.tagName !== 'BUTTON' || event.target.classList.contains('selected')) {
      return;
    }
    const sizeButtons = this.textSizeController.querySelectorAll('button');
    sizeButtons.forEach(function (button) {
      button.classList.remove('selected');
    });

    const clickedButton = event.target;
    clickedButton.classList.add('selected');

    this.isChangeSizeEvent = true;

    this.selectedSize = clickedButton.dataset.size;
    this.maxLines = this.block.options.sizes[this.selectedSize].maxLines;
    this.lineCharacterLimit = this.block.options.sizes[this.selectedSize].lineCharacterLimit;

    this.textarea.value = this.textarea.value.trimEnd();
    this.textarea.focus();

    if (this.preservedText === null) {
      this.preservedText = this.cachedText;
      this.textarea.dataset.preserveText = true;
    }

    this.updateDisplay();

    // this.log({
    //   textSize: this.selectedSize,
    //   maxLines: this.maxLines,
    //   lineCharacterLimit: this.lineCharacterLimit
    // });
  }

  controlTextAlign(event) {
    // do nothing if is already selected
    if (event.target.tagName !== 'BUTTON' || event.target.classList.contains('selected')) {
      return;
    }

    const alignButtons = this.textAlignController.querySelectorAll('button');
    alignButtons.forEach(function (button) {
      button.classList.remove('selected');
    });

    const clickedButton = event.target;
    clickedButton.classList.add('selected');

    this.selectedAlignment = clickedButton.dataset.align;

    this.textarea.focus();
    this.updateDisplay();

    // this.log({textAlign: this.selectedAlignment});
  }

  updateDisplay() {
    // Update the display hidden field
    const size = this.selectedSize.charAt(0).toUpperCase() + this.selectedSize.slice(1);
    const align = this.selectedAlignment.charAt(0).toUpperCase() + this.selectedAlignment.slice(1);
    this.block.el.querySelector(`#${this.block.id}-display`).value = `${size} - ${align}`;

    // Update the textarea
    this.textarea.setAttribute('rows', this.maxLines);

    // A value of 0 means the textarea will not be limited by character width
    if (this.lineCharacterLimit === 0) {
      this.textarea.setAttribute('style', 'width: 100%;');
    } else {
      this.textarea.setAttribute('cols', this.lineCharacterLimit);
      this.textarea.setAttribute('style', `width: ${this.lineCharacterLimit}ch`);
    }

    // Create the text layer settings object
    this.textLayerSettings = {
      path: this.block.options.path || null,
      ...this.block.options.sizes[this.selectedSize],
      textAlign: this.selectedAlignment,
    };

    // Update the text layer settings
    this.canvasLabel = this.canvas.updateLayerSettings(this.canvasLabel, this.textLayerSettings, this.dev);

    // force textarea input event
    this.textarea.value = this.cachedText;
    this.textarea.dispatchEvent(new Event('input'));
  }

  getBlockSettings(fieldset) {
    const blockId = fieldset.dataset.block;
    let blockSettings = {
      id: blockId,
      el: fieldset,
      options: this.config.options,
    };

    if (this.config.blocks && this.config.blocks[blockId]) {
      blockSettings = this.mergeObjectsRecursive(blockSettings, this.config.blocks[blockId]);
    }

    return blockSettings;
  }

  mergeObjectsRecursive(obj1, obj2) {
    const merged = { ...obj1 };

    for (const key in obj2) {
      const obj1HasKey = Object.prototype.hasOwnProperty.call(obj1, key);

      if (obj1HasKey && typeof obj1[key] === 'object' && typeof obj2[key] === 'object') {
        merged[key] = this.mergeObjectsRecursive(obj1[key], obj2[key]);
      } else if (obj1HasKey && obj1[key] !== obj2[key]) {
        merged[key] = obj2[key];
      } else {
        merged[key] = obj2[key];
      }
    }
    return merged;
  }

  log() {
    if (this.dev) {
      // eslint-disable-next-line no-console
      console.log(...arguments);
    }
  }
}

customElements.define('vk-customizable-product-section', VKCustomizableProductSection);
